import pagesConfig from "./pagesConfig";
import Theme from "./theme";
import fonts from "./fonts";
import Colors from "./colors";
import SVG from "./svg";
import Images from "./images";
const { spacing: Spacing } = Theme.Light;

export { pagesConfig, Theme, Spacing, fonts, Colors, SVG, Images };
